import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { localeRoot } from "../../../../constants";
import { FieldWithCounter } from "../../Fields/FieldWithCounter";

const localeFields = "builder.benefits.fields";
const maxTitleLength = 50;

interface TitleFieldProps {
  className?: string;
}

export const TitleField = ({ className }: TitleFieldProps) => (
  <FieldWithCounter
    name="paywall_customization_attributes.benefit_properties.title"
    label={t("title")}
    maxLength={maxTitleLength}
    errorMessage={t([localeRoot, localeFields, "errors", "title_max_length"])}
    className={className}
  >
    <Form.Item
      className="!mt-0 !py-0"
      name="paywall_customization_attributes.benefit_properties.title"
      hideLabel
      hidePlaceholder
      hideBorder
      hideDescription
      rules={{
        maxLength: {
          value: maxTitleLength,
          message: t([localeRoot, localeFields, "errors", "title_max_length"]),
        },
      }}
      variant="extra-bottom-margin"
    >
      <Form.Input />
    </Form.Item>
  </FieldWithCounter>
);
